import { render, staticRenderFns } from "./MoreBenefit.vue?vue&type=template&id=48775b52&scoped=true&"
import script from "./MoreBenefit.vue?vue&type=script&lang=js&"
export * from "./MoreBenefit.vue?vue&type=script&lang=js&"
import style0 from "./MoreBenefit.vue?vue&type=style&index=0&id=48775b52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48775b52",
  null
  
)

export default component.exports